import React from "react";
const UgcCommitteePdf = () => {
  return (
    <section className="w-full bg-[#F7F9FC] py-10 px-4">
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-lg border border-gray-200 p-8 text-center">
        <h2 className="text-2xl sm:text-3xl font-black text-[#13213A]">
          UGC Committee
        </h2>
        <p className="mt-3 text-gray-700 text-sm sm:text-base">
          Click the button below to open the UGC Committee PDF.
        </p>
        <a
          href="/ugc-committee.pdf"
          target="_blank"
          rel="noreferrer"
          className="mt-6 inline-flex bg-yellow-500 text-[#06215F] px-6 py-3 rounded-xl text-sm font-black hover:bg-[#06215F] hover:text-white transition-all"
        >
          Open UGC Committee PDF
        </a>
      </div>
    </section>
  );
};
export default UgcCommitteePdf;